/**
 * The person's initials, e.g. "María Quispe Huamán" → "MQ".
 *
 * Uses the first letter of the first *two* words, which in this domain are the
 * given names: surnames can be several and a one-letter initial ("Q") carries
 * far less meaning than "MQ".
 *
 * Lives outside the component file so `react-refresh` can keep `Avatar` as a
 * component-only module — a re-exported function would break fast refresh for
 * every consumer of the barrel.
 */
export function initials(fullName: string): string {
  const words = fullName.trim().split(/\s+/).filter(Boolean);
  return words
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? '')
    .join('');
}
